import React from "react";

/**
 * Read-only internal notes of the record being processed (work order, inspection, recruiting expense),
 * shown the same way in every pay dialog. Notes are edited on the source record, never here.
 */
export default function ProcessInternalNotes({notes, translate, className = "col-span-2 min-w-0"}) {
    return (
        <div className={className}>
            <div className="mb-2 ml-1">{translate("field.InternalNotes")}</div>
            <textarea
                className="w-full min-h-[120px] resize-y rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 shadow-sm focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-200 disabled:bg-gray-100"
                value={notes ?? ""}
                readOnly={true}
                disabled={true}
            />
            <p className="mt-1 ml-1 text-xs text-tm-gray-500">{translate("text.internal_notes_process_readonly")}</p>
        </div>
    );
}
